import store from '../../store/index'

const routes = [
  {
    path: '/company/tenders',
    name: 'CompanyTenders',
    component: () => import('../../views/company/tender/List.vue')
  },
  // CIC
  {
    path: '/company/tender-jobs',
    name: 'CompanyTenderJobs',
    component: () => import('../../views/company/tender/cic/TenderJobList.vue')
  },
  {
    path: '/company/awarded-tender-jobs',
    name: 'CompanyTenderAwardedJobs',
    component: () => import('../../views/company/tender/cic/AwardedTenders.vue')
  },
  {
    path: '/company/tender-jobs/create',
    name: 'companyTenderJobCategoryCreate',
    component: () => import('../../views/company/tender/cic/CreateJobCategory.vue')
  },
  {
    path: '/company/tender-jobs/edit/:category_id',
    name: 'companyTenderJobCategoryEdit',
    component: () => import('../../views/company/tender/cic/EditJobCategory.vue')
  },
  // End of CIC
  {
    path: '/company/edit/tender/:id',
    name: 'CompanyTender_edit',
    component: () => import('../../views/company/tender/Edit.vue')
  },
  {
    path: '/company/create/tender',
    name: 'CompanyTender_create',
    component: () => import('../../views/company/tender/Create.vue')
  },
  {
    path: '/company/tender/details/:id',
    name: 'CompanyTender_details',
    component: () => import('../../views/company/tender/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'buyer' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/company/tender/create/category/:id',
    name: 'CompanyTender_category_create',
    component: () => import('../../views/company/tender/category/Create.vue')
  },
  {
    path: '/company/tender/create/category/negotiation/:id/:parent_id',
    name: 'CompanyTenderCategoryNegotiation',
    component: () => import('../../views/company/tender/category/CreateNegotiation.vue')
  },
  {
    path: '/company/tender/edit/category/:tender_id/:category_id',
    name: 'CompanyTender_category_edit',
    component: () => import('../../views/company/tender/category/Edit.vue')
  },
  {
    path: '/company/tender/category/details/:tender_id/:category_id',
    name: 'CompanyTender_category_details',
    component: () => import('../../views/company/tender/category/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'buyer' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/company/tender/technical/criteria/upload/progress/:tender_id/:category_id/:task_id',
    name: 'CompanyTender_upload_criteria_Progress',
    component: () => import('../../views/company/tender/category/QuestionUploadProgress.vue')
  },
  {
    path: '/company/tender/technical/criteria/download/progress/:tender_id/:category_id/:task_id',
    name: 'CompanyTender_download_criteria_Progress',
    component: () => import('../../views/company/tender/category/QuestionDownloadProgress.vue')
  },
  {
    path: '/company/tender/category/refresh/scores/:tender_id/:category_id/:task_id',
    name: 'CompanyTenderCategoryRefreshScores',
    component: () => import('../../views/company/tender/category/RefreshScoresProgress.vue')
  },
  {
    path: '/company/tender/financial/details/:tender_id/:category_id',
    name: 'CompanyTender_financial_details',
    component: () => import('../../views/company/tender/category/financial/Details.vue')
  },
  {
    path: '/company/tender/financial/items/upload/:tender_id/:category_id/:task_id',
    name: 'CompanyTender_Upload_Items_Progress',
    component: () => import('../../views/company/tender/category/financial/ItemsUploadProgress.vue')
  },
  {
    path: '/company/tender/question/upload/progress/:tender_id/:task_id',
    name: 'CompanyTenderQuestionUploadProgress',
    component: () => import('../../views/company/tender/QuestionUploadProgress.vue')
  },
  {
    path: '/company/tender/create/section/:tender_id/:category_id',
    name: 'CompanyTender_create_section',
    component: () => import('../../views/company/tender/category/section/Create.vue')
  },
  {
    path: '/company/tender/edit/section/:tender_id/:category_id/:section_id',
    name: 'CompanyTender_edit_section',
    component: () => import('../../views/company/tender/category/section/Edit.vue')
  },
  {
    path: '/company/tender/section/questions/:category_id/:section_id',
    name: 'CompanyTender_section_questions',
    component: () => import('../../views/company/tender/category/section/Questions.vue')
  },
  {
    path: '/company/tender/create/question/:category_id/:section_id',
    name: 'CompanyTender_create_question',
    component: () => import('../../views/company/tender/category/section/CreateQuestion.vue')
  },
  {
    path: '/company/tender/edit/question/:category_id/:section_id/:id',
    name: 'CompanyTender_edit_question',
    component: () => import('../../views/company/tender/category/section/EditQuestion.vue')
  },
  {
    path: '/company/tender/reports/:tender_id/:category_id',
    name: 'CompanyTender_reports_category',
    component: () => import('../../views/company/tender/category/reports/Reports.vue')
  },
  {
    path: '/company/tender/award/:tender_id/:category_id',
    name: 'CompanyTender_award_category',
    component: () => import('../../views/company/tender/category/award/Award.vue')
  },
  {
    path: '/company/tender/qa/instructions/:category_id',
    name: 'CompanyTender_qa_instructions',
    component: () => import('../../views/company/tender/category/qa/AddInstructions.vue')
  },
  {
    path: '/company/tender/evaluation/instructions/:category_id',
    name: 'CompanyTender_evaluation_instructions',
    component: () => import('../../views/company/tender/category/evaluation/AddInstructions.vue')
  },
  {
    path: '/company/tender/conduct/qa/:category_id/:participant_id',
    name: 'CompanyTender_conduct_qa',
    component: () => import('../../views/company/tender/category/qa/ConductQa.vue')
  },
  {
    path: '/company/tender/conduct/evaluation/suppliers/:tender_id/:category_id',
    name: 'CompanyTender_conduct_evaluation_suppliers',
    component: () => import('../../views/company/tender/category/evaluation/EvaluationSuppliers.vue')
  },
  {
    path: '/company/tender/conduct/qa/suppliers/:tender_id/:category_id',
    name: 'CompanyTender_conduct_qa_suppliers',
    component: () => import('../../views/company/tender/category/qa/QASuppliers.vue')
  },
  {
    path: '/company/tender/conduct/evaluation/scores/:tender_id/:category_id',
    name: 'CompanyTender_conduct_evaluation_scores',
    component: () => import('../../views/company/tender/category/evaluation/EvaluationScores.vue')
  },
  {
    path: '/company/tender/conduct/evaluation/:category_id/:participant_id',
    name: 'CompanyTender_conduct_evaluation',
    component: () => import('../../views/company/tender/category/evaluation/ConductEvaluation.vue')
  },
  {
    path: '/company/tender/dd/details/:category_id',
    name: 'CompanyTender_dd_details',
    component: () => import('../../views/company/tender/category/dd/Participants.vue')
  },
  {
    path: '/company/tender/dd/conduct/:category_id/:participant_id/:question_id',
    name: 'CompanyTender_dd_conduct',
    component: () => import('../../views/company/tender/category/dd/ConductDD.vue')
  },
  {
    path: '/company/tender/dd/add/questions/:category_id',
    name: 'CompanyTender_dd_add_questions',
    component: () => import('../../views/company/tender/category/dd/AddDDWideQuestions.vue')
  },
  {
    path: '/company/tender/dd/add/supplier/questions/:category_id/:participant_id',
    name: 'CompanyTender_dd_add_supplier_questions',
    component: () => import('../../views/company/tender/category/dd/AddPerSupplierQuestion.vue')
  },
  {
    path: '/company/tender/dd/supplier/questions/:category_id/:participant_id',
    name: 'CompanyTender_dd_supplier_questions',
    component: () => import('../../views/company/tender/category/dd/SupplierQuestions.vue')
  },
  {
    path: '/company/tender/letters/:job_id/:category_id',
    name: 'CompanyTender_letters',
    component: () => import('../../views/company/tender/category/letters/ParticipantList.vue')
  },
  {
    path: '/company/tender/preview/award/letter/:job_id/:category_id/:supplier_id',
    name: 'CompanyTender_preview_award_letter',
    component: () => import('../../views/company/tender/category/letters/award_letter/PreviewLetter.vue')
  },
  {
    path: '/company/tender/preview/regret/letter/:job_id/:category_id/:supplier_id',
    name: 'CompanyTender_preview_regret_letter',
    component: () => import('../../views/company/tender/category/letters/regret_letter/PreviewLetter.vue')
  },
  {
    path: '/company/tender/reports/:id',
    name: 'CompanyTender_reports',
    component: () => import('../../views/company/tender/reports/Details.vue')
  },
  {
    path: '/company/tender/report/progress/:tender_id/:task_id',
    name: 'CompanyTenderReportsProgress',
    component: () => import('../../views/company/tender/reports/Progress.vue')
  },
  {
    path: '/company/tender/invited/suppliers/:tender_id/:category_id',
    name: 'CompanyTender_invited_suppliers',
    component: () => import('../../views/company/tender/category/InvitedSuppliers.vue')
  },
  {
    path: '/company/tender/invite/system/suppliers/:tender_id/:category_id',
    name: 'CompanyTenderInviteSystemSuppliers',
    component: () => import('../../views/company/tender/category/SystemSuppliers.vue')
  },
    {
    path: '/company/tender/letters/jobs',
    name: 'CompanyTLetterJobs',
    component: () => import('../../views/company/tender/category/letters/LetterJobs.vue')
  },
  {
    path: '/company/tender/letters/:job_id',
    name: 'CompanyTLetterCategories',
    component: () => import('../../views/company/tender/category/letters/LetterCategories.vue')
  },
  {
    path: '/company/tender/letters/success/create/:job_id',
    name: 'CompanyTLetterSuccessCreate',
    component: () => import('../../views/company/tender/category/letters/award_letter/CreateAward.vue')
  },
  {
    path: '/company/tender/letters/success/edit/:job_id',
    name: 'CompanyTLetterSuccessEdit',
    component: () => import('../../views/company/tender/category/letters/award_letter/EditAwardLetter.vue')
  },
  {
    path: '/company/tender/letters/custom/create/:job_id',
    name: 'CompanyTLetterCustomCreate',
    component: () => import('../../views/company/tender/category/letters/custom/CreateCustom.vue')
  },
    {
    path: '/company/tender/letters/custom/edit/:job_id',
    name: 'CompanyTLetterCustomEdit',
    component: () => import('../../views/company/tender/category/letters/custom/EditCustomLetter.vue')
  },
  {
    path: '/company/tender/letters/dd/create/:job_id',
    name: 'CompanyTLetterDDCreate',
    component: () => import('../../views/company/tender/category/letters/dd_letter/CreateDD.vue')
  },
  {
    path: '/company/tender/letters/dd/edit/:job_id',
    name: 'CompanyTLetterDDEdit',
    component: () => import('../../views/company/tender/category/letters/dd_letter/EditDDLetter.vue')
  },
  {
    path: '/company/tender/letters/regret/create/:job_id',
    name: 'CompanyTLetterRegretCreate',
    component: () => import('../../views/company/tender/category/letters/regret_letter/CreateRegret.vue')
  },
  {
    path: '/company/tender/letters/regret/edit/:job_id',
    name: 'CompanyTLetterRegretEdit',
    component: () => import('../../views/company/tender/category/letters/regret_letter/EditRegretLetter.vue')
  },
    {
    path: '/company/tender/zip/files/progress/:task_id/:section_id',
    name: 'CompanyPrequalZipFiles',
    component: () => import('../../views/company/tender/category/ZipFilesProgress.vue')
  },
    {
    path: '/company/tender/cat/suppliers/progress/:tender_id/:task_id/',
    name: 'CompanyTenderCatSuppliers',
    component: () => import('../../views/company/tender/CatSuppliersProgress.vue')
  },
  {
    path: '/company/tender/duplicate/category/:tender_id/:category_id',
    name: 'CompanyTenderDuplicateCategory',
    component: () => import('../../views/company/tender/CloneCategory.vue')
  },
  {
    path: '/company/tender/duplicate/job-category/:tender_id/:category_id',
    name: 'CompanyTenderDuplicateJobCategory',
    component: () => import('../../views/company/tender/cic/CloneCategory.vue')
  },
  {
    path: '/company/tender/prices/download/progress/:tender_id/:task_id',
    name: 'CompanyTenderPricesDownloadProgress',
    component: () => import('../../views/company/tender/category/DownloadProgress.vue')
  },
  {
    path: '/company/tender/invite/from/prequal/list/:tender_id/:category_id',
    name: 'CompanyTenderPrequals',
    component: () => import('../../views/company/tender/category/invitees/Prequalifications.vue')
  },
  {
    path: '/company/tender/invite/from/prequal/category/:tender_id/:category_id/:prequal_id',
    name: 'CompanyTenderPrequalCategories',
    component: () => import('../../views/company/tender/category/invitees/PrequalCategories.vue')
  },
  {
    path: '/company/tender/invite/from/prequal/category/suppliers/:tender_id/:category_id/:prequal_id/:p_cat_id',
    name: 'CompanyTenderPrequalCategorySuppliers',
    component: () => import('../../views/company/tender/category/invitees/PrequalCategorySuppliers.vue')
  }
]

export default routes;
